module.exports = __webpack_public_path__ + "img/trunk_bg_deco.aeb34c93.png";